import styled from "styled-components";

export const HistoryStyle = styled.div`
  margin-inline: 20px;
  padding-block: 75px;
`;

export const TransactionCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`